import * as z from "zod/v4";
import { aeoDashboardFilterInput } from "./types";

const citationSourceEntry_ = z.object({
  domain: z.string(),
  referenceCount: z.number().int(),
  share: z.number(),
});

export const getAeoDashboardCitations = {
  name: "getAeoDashboardCitations" as const,
  input: aeoDashboardFilterInput,
  output: z.object({ sources: z.array(citationSourceEntry_) }),
};
